<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('apply.no')" prop="applyNo">
                    <el-input v-model="queryCondition.applyNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.applyType')" prop="applyType">
                    <el-select v-model="queryCondition.applyType" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.subject')" prop="subject">
                    <el-input v-model="queryCondition.subject" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                    <el-select v-model="queryCondition.quotationType" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierCode">
                      <el-input :disabled="true" v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.roundStatus')" prop="roundStatus">
                      <el-select v-model="queryCondition.roundStatus" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in roundStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('common.createBy')" prop="buyerName">
                      <el-input v-model="queryCondition.buyerName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis()" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-table sortable max-height="435" :data="quotationList" ref="quotationDataTable" border highlight-current-row>
        <el-table-column show-overflow-tooltip fixed sortable prop="applyNo" :label="$t('apply.no')" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="applyTypeI18n" :label="$t('apply.applyType')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" :label="$t('apply.subject')" min-width="180px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" :label="$t('apply.shortlistedSuppliers')" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="quotationTypeI18n" :label="$t('apply.quotationType')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundNumber" :label="$t('common.operation')" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationDetail(scope.row)" v-if="scope.row.roundStatus!=='4'"> {{$t('common.quote')}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundNumber" :label="$t('apply.round')" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationHistory(scope.row.ttQuotationApplyId)"> {{scope.row.roundNumber}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundStatusI18n" :label="$t('apply.roundStatus')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" :label="$t('common.createBy')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="100px"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { quotationSearchService } from "../../../api/quotation-apply-sup/quotation-search";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
import { Message } from "element-ui";
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
export default {
  name: 'quotation-search',
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      totalCount: 0,
      quotationList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        quotationType: null,
        supplierCode: null,
        roundStatus: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
        roundNumber: null,
      },
      roundStatusList: [],
      quotationStatusList: [],
      sourcingStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      ttQuotationApplyId: null,
      supplierCode: '',
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    quotationSearchService.getQuotationListData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.quotationList = res.resultData;
        vm.totalCount = res.totalCount;
        vm.supplierCode = res.otherInfo;
      })
    })
  },
  created() {
    //this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      quotationSearchService.getQuotationListData(this.queryCondition).then((res) => {
        this.quotationList = res.resultData;
        this.totalCount = res.totalCount;
        this.supplierCode = res.otherInfo;
      });
    },
    openQuotationDetail: function (row) {
      if (row.status == '3' && !row.ttQuotationId) {
        Message({ message: '申请单已经关闭，不能继续进行报价!', type: "warning" });
        return;
      }
      if (this.actionCheck.actionCheck('QuotationInit') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.replace({ name: 'quotationSpDetail', params: { roundId: row.ttQuotationApplyRoundId } });
    },
    openQuotationHistory: function (applyId) {
      if (this.actionCheck.actionCheck('QuotationHistory') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.replace({ name: 'quotationSpHistory', params: { applyId: applyId } });
    },
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck('ApplyInfo') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.replace({ name: 'applySpDetail', params: { applyId: row.ttQuotationApplyId, source: 'quotation' } });
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"] = "TT_QUOTATION_APPLY_ROUND:ROUND_STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.roundStatusList = res["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    checkRoundNumber: function (val) {
      if (undefined != val) {
        let reg = /^(0|[1-9]\d{0,9})$/;
        if (!reg.test(val)) {
          this.queryCondition.roundNumber = 1;
        }
      }
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        quotationType: null,
        supplierCode: null,
        roundStatus: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
        roundNumber: null,
      }
      this.queryData()
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
.el-input {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
